<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="hideModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">New Key</h4>
            </div>
            <div class="modal-body">
                <!-- ___ Key Tag ___ -->
                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Key Tag</label>
                    </div>
                    <div class="col-md-8 fourteenPixelText">
                        {{data.keyTag}}
                    </div>
                </div>

                <!-- ___ Building ___ -->
                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Building</label>
                    </div>
                    <div class="col-md-8 fourteenPixelText">
                        {{data.buildingName}}
                    </div>
                </div>

                <!-- ___ Unit ___ -->
                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Unit</label>
                    </div>
                    <div class="col-md-8">
                        {{data.suiteNumber}}
                    </div>
                </div>

                <!-- ___ Purpose ___ -->
                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Purpose</label>
                    </div>
                    <div class="col-md-8 fourteenPixelText">
                        {{data.purpose}}
                    </div>
                </div>

                <!-- ___ Status ___ -->
                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Status</label>
                    </div>
                    <div class="col-md-8 fourteenPixelText">
                        <span *ngIf="data.status == 'signet_out'">Signed Out</span>
                        <span *ngIf="data.status == 'available'">Available</span>
                    </div>
                </div>

                <!-- ___ Notes  ___ -->
                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Notes</label>
                    </div>
                    <div class="col-md-8 fourteenPixelText">
                        {{data.notes}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/key-log/key-log-view/key-log-view.component.html